import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { productDetailPath } from "../../constants/routes";
import { useLocalizedProduct } from "../../hooks/useLocalizedProduct";
import { useCartStore } from "../../store/cartStore";
import ProductSummary from "./ProductSummary";
import "./ProductCard.css";

function ProductCard({ product, showAddToCart = false }) {
  const { t } = useTranslation();
  const localizedProduct = useLocalizedProduct(product);
  const addItem = useCartStore((state) => state.addItem);
  const [added, setAdded] = useState(false);

  if (!localizedProduct) return null;

  const detailPath = productDetailPath(localizedProduct.slug);

  const handleAddToCart = (event) => {
    event.preventDefault();
    event.stopPropagation();
    addItem(localizedProduct, 1);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 2000);
  };

  return (
    <article className="caf-product-card">
      <Link to={detailPath} className="caf-product-card__link">
        <div className="caf-product-card__media">
          {localizedProduct.image ? (
            <img
              src={localizedProduct.image}
              alt={localizedProduct.name}
              className="caf-product-card__image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="caf-product-card__placeholder" aria-hidden="true" />
          )}
        </div>

        <div className="caf-product-card__body">
          <ProductSummary product={localizedProduct} titleTag="h3" />
        </div>
      </Link>

      <div className="caf-product-card__footer">
        {showAddToCart ? (
          <button
            type="button"
            className="caf-product-card__btn"
            onClick={handleAddToCart}
            disabled={!localizedProduct.purchasable || !localizedProduct.inStock}
          >
            <FaShoppingCart className="caf-product-card__btn-icon" aria-hidden="true" />
            <span>{added ? t("Added to cart") : t("Add to cart")}</span>
          </button>
        ) : (
          <Link to={detailPath} className="caf-product-card__btn caf-product-card__btn--outline">
            {t("View product")}
          </Link>
        )}
      </div>
    </article>
  );
}

export default ProductCard;
